import React, { useState } from "react";
import AvatarList from "./avatar-list";
import TopicList from "./topic-list";

const Menu = ({ source, handleShowMenu, language, topicList, avatarList, selectedTopic, handleMenuClick, handleSelectAvatar, handleSetTopic, selectedMenu}) => {
  
  return (
    <>
      <div className="navbar">
        <div className="close-menu" style={{ visibility: "hidden" }}>
          <img src={`${process.env.PUBLIC_URL}/assets/bg-close-button.png`} alt="Close Menu" />
        </div>
        <div className="menu__title">
          <p>{selectedMenu}</p>
        </div>
        <div className="close-menu" onClick={handleShowMenu}>
          <img src={`${process.env.PUBLIC_URL}/assets/bg-close-button.png`} alt="Close Menu" />
        </div>
      </div>
      {
        selectedMenu === "MENU" ? (
          <div className="menu__content">
            <div
              className={`menu__item ${source}`}
              onClick={() => handleMenuClick("EXPORT")}
            >
              <p>{language === "english" ? "EXPORT TRANSCRIPT" : "EKSPOR TRANSKRIP"}</p>
            </div>
            <div
              className={`menu__item ${source}`}
              onClick={() => handleMenuClick("CHANGE AVATAR")}
            >
              <p>{language === "english" ? "CHANGE AVATAR" : "GANTI AVATAR"}</p>
            </div>
            {/* {
              source !== "classroom" && source !== "hospital" ? 
              <div
              className={`menu__item ${source}`}
              onClick={() => handleMenuClick("CHANGE TOPIC")}
            >
              <p>{language === "english" ? "SWITCH TOPIC" : "GANTI TOPIK"}</p>
            </div>
            : null
            } */}
            <div
              className={`menu__item ${source}`}
              onClick={() => handleMenuClick("LOCALISATION")}
            >
              <p>{language === "english" ? "SWITCH TO BAHASA" : "GANTI KE INGGRIS"}</p>
            </div>
            <div
              className={`menu__item disable ${source}`}
              // onClick={() => handleMenuClick("PLAY A GAME")}
            >
              <p>{language === "english" ? "PLAY A GAME" : "BERMAIN GAME"}</p>
            </div>
          </div>
        ) : selectedMenu === "CHANGE AVATAR" ? (
         
          <AvatarList avatarList={avatarList} handleSelectAvatar={handleSelectAvatar} origin={source}/>
        ) : selectedMenu === "CHANGE TOPIC" ? (
          <TopicList topicList={topicList} selectedTopic={selectedTopic} handleSetTopic={handleSetTopic} source={source}/>
        ) : null /* Add additional submenus for other selectedMenu values here */
      }
    </>
  );
};

export default Menu;
